// Code-drawn pixel icon of the EMP kunai (a ringed throwing blade with an electric glow), for menus.
// Palette colours only (client/src/theme.ts); the in-world kunai is drawn by render.ts.
import { PALETTE } from './theme';

let cached = '';
/** A 16x16 data URL, drawn once. Show it scaled up with `image-rendering: pixelated`. */
export function kunaiIcon(): string {
  if (cached) return cached;
  const cv = document.createElement('canvas'); cv.width = cv.height = 16;
  const g = cv.getContext('2d');
  if (!g) return '';
  const px = (x: number, y: number, c: string, a = 1) => { g.globalAlpha = a; g.fillStyle = c; g.fillRect(x, y, 1, 1); };
  // glow
  for (let y = 3; y < 13; y++) for (let x = 3; x < 13; x++) if (Math.hypot(x - 7.5, y - 7.5) < 5.5) px(x, y, PALETTE.cyan, 0.16);
  // blade along the diagonal, ring at the tail
  for (let i = 0; i < 9; i++) { px(4 + i, 11 - i, PALETTE.offWhite); if (i > 1 && i < 8) px(5 + i, 11 - i, PALETTE.slate); }
  px(13, 2, PALETTE.cyan); px(12, 2, PALETTE.cyan); px(13, 3, PALETTE.cyan);
  for (const [x, y] of [[2, 12], [3, 13], [2, 13], [1, 12], [2, 11], [3, 12]]) px(x, y, PALETTE.offWhite);
  px(2, 12, PALETTE.midnight);
  // lightning crackle
  for (const [x, y] of [[8, 13], [9, 12], [9, 13], [10, 14], [4, 5], [5, 4], [4, 4], [3, 3]]) px(x, y, PALETTE.cyan);
  cached = cv.toDataURL();
  return cached;
}

export const kunaiImg = (px = 20) => `<img alt="" src="${kunaiIcon()}" width="${px}" height="${px}" style="image-rendering:pixelated;vertical-align:middle">`;
